import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Scrollbar} from 'react-scrollbars-custom';
import {checkIsDifferentDay, checkIsEmptyMessage, getActualNotifMessages, isSeen} from '../../helpers/message';
import {toGQLId} from '../../helpers/parse';
import {getResize, getSourceUrl} from '../../helpers/file';
import {ParseEntity} from '../../types/parse';
import {CreateMsgFields, IDataHookMessage, MobTabMsgs, TContact} from '../../types/messages';
import {Message, TypeMsg} from '../../queries/types/message';
import {EmptyCard} from '../../ui-kit/Chat/EmptyCard';
import {IconSvg} from '../../ui-kit/Icon/Svg';
import {ContentLoader} from '../../ui-kit/Loader/ContentLoader';
import {MessageBox} from './MessageBox';
import {
  BaseChatLoader,
  BtnDelImg,
  CustomScrollbar,
  FormChat,
  ImgMsg,
  InnerEmptyCard,
  InnerImages,
  InnerImgMsg,
  ThumbStyles,
  WrapMsgBox,
  ChatAreaSend,
  AddFileWrapper,
  ChatInputWrapper,
  LastMessageAnchor,
} from './styles';
import {useRecoilState, useSetRecoilState} from 'recoil';
import {typeUser} from '../../states/typeUser';
import {getUserName} from '../../helpers/user';
import {EmojiTab} from '../common/EmojiTab/EmojiTab';
import {RichTextEditor} from '../common/RichText/Editor';
import {handleEditorChangeForUserEvent, handleSetUser, handleSetEvent} from '../../helpers/common';
import {UserMenu} from '../Account/Popups/HeaderMenu/UserMenu';
import {EventMenu} from '../Account/Popups/HeaderMenu/EventMenu';
import {Button} from '../../ui-kit/Button/Button';
import {RTEdefault} from '../../constants/common';
import {LabelInputAction} from '../../ui-kit/Chat/styles';
import {FileInput} from '../../ui-kit/Form/ImageLoader/FileInput';
import {isModal} from '../../states/themeMode';
import {isMobile} from 'react-device-detect';

type TProps = {
  messages?: Message[] | null;
  contact?: TContact | null;
  viewerId?: string;
  viewerData?: {
    name?: string;
    avatar?: string;
  };
  dataHookMessage: IDataHookMessage;
  setActiveOrder: (id?: string) => void;
  setActiveMobTab?: (tab: MobTabMsgs | null) => void;
  isSearching: boolean;
  setIsSearching: (value: boolean) => void;
  commId?: string;
  setInputFocus?: (val: boolean) => void;
  activeOrder?: boolean;
  keyboardOpened?: boolean;
};

/*type PreviewImg = {
  previewImg?: string;
  images: string[];
};*/

const LabelImageButton: React.FC<{onAddImage?: () => void}> = ({children}) => {
  return (
    <LabelInputAction>
      <IconSvg type={'circled-plus'} stroke={'gray'} />
      {children}
    </LabelInputAction>
  );
};

export const ChatArea: React.FC<TProps> = ({
  viewerId,
  contact,
  messages,
  dataHookMessage,
  setActiveOrder,
  setActiveMobTab,
  isSearching,
  setIsSearching,
  commId,
  setInputFocus,
  activeOrder,
  keyboardOpened,
}) => {
  const {t} = useTranslation();
  const chatContainer = React.useRef<(HTMLDivElement & Scrollbar) | null>(null);
  const [unseenMsgRef, setUnseenMsgRef] = useState<HTMLDivElement | null>(null);
  const [isInitialScrollDone, setIsInitialScrollDone] = useState(false);
  // const [lastWrittenMsg, setLastMsg] = useState<Message>();
  const [textEditorRef, setTextEditorRef] = useState<{blur: () => void; focus: () => void}>();
  const msgsBox = useRef<HTMLDivElement>(null);
  const lastMessageRef = useRef<HTMLDivElement>(null);
  const bottom = useRef<HTMLDivElement>(null);
  const [modalOpened] = useRecoilState(isModal);
  //const [activeImg, setActiveImg] = useState<PreviewImg | null>(null);
  /*(const imagePreviewToggle = (f: PreviewImg) => {
    setActiveImg(f);
  };*/
  const [userType] = useRecoilState(typeUser);
  const [messageValue, setMessageValue] = useState('');
  //const closePreviewImg = () => setActiveImg(null);
  const {values: message, onChange, onSubmit, deleteImage, updateSeenMsg, LoadingCreateMsg: loading} = dataHookMessage;
  const [emoji, setEmoji] = useState<string>('');
  const [searchText, setSearchText] = useState('');
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [eventMenuOpen, setEventMenuOpen] = useState(false);
  const [userProfile, setUserProfile] = useState<string>('');
  const [eventName, setEventName] = useState<string>('');
  const setIsModal = useSetRecoilState(isModal);
  const [positionSubMenu, setPositionSubMenu] = useState({top: 0, left: 0});

  const handleChane = (next: {name: string; value: string; key: string}, pos: any, existingValues: string) => {
    handleEditorChangeForUserEvent(
      next,
      pos,
      existingValues,
      positionSubMenu,
      setPositionSubMenu,
      userMenuOpen,
      setUserMenuOpen,
      eventMenuOpen,
      setEventMenuOpen,
      setSearchText,
    );
    handleChangeLocal(next.value); //update local state
    // handleChange?.(next.value);
  };

  const shouldBecomeSeen = (msg: Message) => {
    if (isSeen(msg, viewerId)) return false;

    const isFromViewer = msg?.Author?.objectId === viewerId;

    return !isFromViewer;
  };

  const getFirstUnseenMessageIndex = (msgs: Message[]): number => {
    if (isInitialScrollDone) return -1;

    return msgs?.findIndex((it) => {
      const isFromViewerMessage = it?.Author?.objectId === viewerId;
      const seen = isSeen(it, viewerId);
      return !seen && !isFromViewerMessage;
    });
  };

  const handleSeenMessage = (msg: Message) => () => {
    if (!msg?.objectId || !shouldBecomeSeen(msg) || msg?.isLocal) return;
    updateSeenMsg({
      seen: [toGQLId(ParseEntity.Message, msg.objectId)],
      msg: msg,
    });
  };

  /*useEffect(() => {
    // msgsBox.current?.scrollIntoView({block: 'end'});
  }, [loading]);*/

  useEffect(() => {
    if (!messages?.length) return;
    if (!chatContainer.current || !lastMessageRef.current) return;
    if (isInitialScrollDone) {
      lastMessageRef.current.scrollIntoView();
      return;
    }
    if (getFirstUnseenMessageIndex(messages) === -1) {
      lastMessageRef.current.scrollIntoView();
      return setIsInitialScrollDone(true);
    }

    if (unseenMsgRef) {
      const spaceAbove = 20;
      chatContainer.current.scrollTo(0, unseenMsgRef.offsetTop - spaceAbove);
      return setIsInitialScrollDone(true);
    }
  }, [unseenMsgRef, chatContainer.current, messages?.length]);

  const handleChangeLocal = (value: string) => setMessageValue(value);
  // const handleChange = (value: string) => {
  //   onChange({name: CreateMsgFields.text, value});
  // };

  const handleChangeImage = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange({name: CreateMsgFields.Attachments, value: Object.values(event.target.files || {})});
    event.target.files = null;
    event.target.value = '';
  };

  const handleDeleteImage = (index: number) => () => {
    deleteImage(index);
  };
  const {actualMessages} = getActualNotifMessages(messages);
  const isEmptyMessage = checkIsEmptyMessage(messageValue) && !message?.Attachments?.length;
  const handleSubmit = () => {
    if (isEmptyMessage) return;
    setMessageValue('');
    onSubmit(messageValue);
    // bottom?.current?.scrollIntoView();
  };

  const onEditorKeydown = (ev: React.KeyboardEvent<HTMLDivElement>) => {
    if (ev.keyCode === 13 && !ev.shiftKey) {
      handleSubmit();
      setTimeout(() => {
        setMessageValue('');
      }, 1);
    }
  };

  const handleSetSearching = () => setIsSearching(true);

  const emojiHandleChange = (str: string) => {
    setEmoji(str);
  };
  const title = commId
    ? isSearching
      ? t('messages:emptyState.chat.text3')
      : contact?.name
      ? t('messages:emptyState.chat.message')
      : t('messages:emptyState.chat.text1')
    : t('messages:emptyState.chat.selectComm');

  const onInputFocus = () => setInputFocus?.(true);
  const onInputBlur = () => setInputFocus?.(false);

  const setEditorRef = (ref: any) => {
    if (!textEditorRef) {
      setTextEditorRef(ref);
    }
  };

  useEffect(() => {
    if (textEditorRef) {
      if (isMobile && activeOrder) textEditorRef?.blur();
      // if (isMobile && !activeOrder) textEditorRef?.focus();
    }
  }, [!!textEditorRef, activeOrder]);
  useEffect(() => {
    if (keyboardOpened && lastMessageRef?.current) {
      lastMessageRef.current.scrollIntoView();
    }
  }, [keyboardOpened]);
  const messageWithStatus = [...actualMessages].reverse()?.find((data) => data.Author?.objectId === viewerId)?.objectId;
  return (
    <>
      {!actualMessages?.length && !loading ? (
        <>
          {dataHookMessage?.loading ? (
            <BaseChatLoader>
              <ContentLoader />
            </BaseChatLoader>
          ) : (
            <InnerEmptyCard>
              <EmptyCard
                title={title}
                description={contact?.name ? t('messages:emptyState.chat.text2', {name: contact.name}) : ''}
                imageSvg={
                  <IconSvg
                    stroke={'none'}
                    type={'no-messages-light'}
                    width={'200px'}
                    height={'200px'}
                    viewBox="0 0 200 200"
                  />
                }
              />
              {!contact?.name && !isSearching && commId && (
                <Button variant={'primary'} width={'240px'} onClick={handleSetSearching}>
                  {t('messages:emptyState.chat.new')}
                </Button>
              )}
            </InnerEmptyCard>
          )}
        </>
      ) : (
        <CustomScrollbar
          $isModalOpened={modalOpened}
          noScrollX={true}
          ref={chatContainer}
          thumbYProps={{
            // eslint-disable-next-line react/display-name
            renderer: (props: any) => {
              const {elementRef, style, ...restProps} = props;
              return <span style={{...style, ...ThumbStyles}} {...restProps} ref={elementRef} className="tHuMbY" />;
            },
          }}
          trackYProps={{
            // eslint-disable-next-line react/display-name
            renderer: (props: any) => {
              const {elementRef, style, ...restProps} = props;
              return (
                <span
                  {...restProps}
                  ref={elementRef}
                  style={{...style, background: 'transparent'}}
                  className="trackYChat"
                />
              );
            },
          }}>
          <WrapMsgBox ref={msgsBox}>
            {actualMessages?.map((data, index) => {
              const isOwner = data.Author?.objectId === viewerId;
              const name = getUserName(userType, data?.Author?.firstName, data?.Author?.lastName);
              const avatar = getResize(data.Author?.Avatar?.file?.url, 'lg');
              const nextMessage = index + 1 < actualMessages?.length ? actualMessages?.[index + 1] : undefined;
              const prevMessage = index - 1 >= 0 ? actualMessages?.[index - 1] : undefined;
              const isDifferentDayNext = checkIsDifferentDay(nextMessage?.createdAt, data?.createdAt);
              const isDifferentDay = checkIsDifferentDay(prevMessage?.createdAt, data?.createdAt);
              const isEndOfBlock = nextMessage?.Author?.objectId !== data.Author?.objectId || isDifferentDayNext;
              const showStatus = messageWithStatus === data.objectId;
              return (
                <MessageBox
                  key={data.objectId}
                  onSeen={handleSeenMessage(data)}
                  name={name}
                  avatar={avatar}
                  message={data}
                  authorId={data.Author?.objectId}
                  isSeen={isSeen(data, data?.ShowTo?.find((it) => it?.objectId !== data.Author?.objectId)?.objectId)}
                  isOwner={isOwner}
                  setRef={getFirstUnseenMessageIndex(actualMessages) === index ? setUnseenMsgRef : null}
                  setActiveOrder={setActiveOrder}
                  setActiveMobTab={setActiveMobTab}
                  //imagePreviewToggle={imagePreviewToggle}
                  author={data.Author}
                  viewerId={viewerId}
                  isNote={data.type === TypeMsg.internalNote}
                  isEndOfBlock={isEndOfBlock}
                  isDifferentDay={isDifferentDay}
                  setIsModal={setIsModal}
                  localStatus={data.localStatus}
                  showStatus={showStatus}
                />
              );
            })}
            {/* <SendingMessageBox
              key={'loading-message'}
              message={lastWrittenMsg}
              name={viewerData?.name}
              avatar={viewerData?.avatar}
              active={loading}
              countMsgs={actualMessages.length}
            /> */}
          </WrapMsgBox>
          <LastMessageAnchor ref={lastMessageRef} />
        </CustomScrollbar>
      )}
      {message?.Attachments && message?.Attachments?.length > 0 && (
        <InnerImages>
          {message?.Attachments?.map((img: any, index) => (
            <InnerImgMsg key={img.name}>
              <ImgMsg src={getSourceUrl(img)} alt={'item photo'} />
              <BtnDelImg onClick={handleDeleteImage(index)}>
                <IconSvg type={'close'} width={'10px'} height={'10px'} stroke={'red'} viewBox={'0 0 20 20'} />
              </BtnDelImg>
            </InnerImgMsg>
          ))}
        </InnerImages>
      )}
      {contact?.objectId && commId && (
        <FormChat>
          <ChatInputWrapper>
            <RichTextEditor
              placeholder={t('forms:placeholderMsgInput')}
              name={'text'}
              value={messageValue}
              onChange={(e, position) => handleChane(e, position, messageValue ? messageValue : RTEdefault)}
              rows={8}
              emoji={emoji}
              setEmoji={setEmoji}
              userProfile={userProfile}
              setUserProfile={setUserProfile}
              // onAddImage={handleChangeImage}
              eventName={eventName}
              setEventName={setEventName}
              noInitialText={true}
              onFocus={onInputFocus}
              onBlur={onInputBlur}
              inputRef={setEditorRef}
              onKeyDown={onEditorKeydown}
            />
            <AddFileWrapper>
              <FileInput
                $isDisable={loading || !contact}
                label={LabelImageButton}
                handleChange={handleChangeImage}
                multiple={true}
              />
            </AddFileWrapper>
            <EmojiTab onlyEmoji={true} onChange={emojiHandleChange} value={message?.text} />
            {userMenuOpen && (
              <UserMenu
                top={positionSubMenu.top}
                left={positionSubMenu.left}
                handleSetUser={handleSetUser}
                setUserProfile={setUserProfile}
                searchText={searchText}></UserMenu>
            )}
            {eventMenuOpen && (
              <EventMenu
                top={positionSubMenu.top}
                left={positionSubMenu.left}
                handleSetEvent={handleSetEvent}
                setEventName={setEventName}
                searchText={searchText}></EventMenu>
            )}
            <ChatAreaSend
              onTouchStart={isMobile ? handleSubmit : undefined}
              onClick={!isMobile ? handleSubmit : undefined}>
              <IconSvg
                type={'circled-arrow'}
                width={'24px'}
                height={'24px'}
                stroke={isEmptyMessage ? 'darkgray' : 'aqua'}
              />
            </ChatAreaSend>
          </ChatInputWrapper>
          <div ref={bottom} />
        </FormChat>
      )}
      {/*
      <PreviewImage
        previewImg={activeImg?.previewImg ?? ''}
        images={activeImg?.images ?? []}
        handleClose={closePreviewImg}
        closeOutside={true}
      />
      */}
    </>
  );
};
